import * as React from "react";
import DataSource, { DATE_DISPLAY_FORMAT } from "../lib/DataSource";
import { Row, Space, Table } from "antd";
import Moment from "moment";
import { FetchWithAuth } from "digimaker-ui/util";
import { Link } from "react-router-dom";

export default class SubjectList extends React.Component<{}, { data: any }> {
  constructor(props: any) {
    super(props);
    this.state = { data: [] };
  }

  componentDidMount() {
    FetchWithAuth("icd/subject/list")
      .then((data) => {
        this.setState({ data: data.data });
      })
      .catch((err) => {
        this.setState(() => {
          throw err;
        });
      });
  }

  render() {
    return (
      <div>
        <div className="main-top">
          <h2>Subjects</h2>
        </div>
        <table className="table">
          <tbody>
            <tr>
              <th>Subject</th>
              <th>Code</th>
              <th>Credit</th>
              <th></th>
            </tr>
            {this.state.data.map((item) => (
              <tr>
                <td>{item.name}</td>
                <td>{item.code}</td>
                <td>{item.credit}</td>
                <td>
                  <Link to={"/subject/view/" + item.id}>View</Link> &nbsp;
                  <Link to={"/subject/view" + item.id}>
                    <i className="fa fa-trash"></i>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}
